export class Scope {
  label: string;
  description: string;
}

export interface RouteData {
  grantedScopes: Scope[];
}